import { StorageContainer } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

export interface SingleStorageContainerQuery {
  singleStorageContainer: StorageContainer
}

export interface SingleStorageContainerVariables {
  id: GQL_ID
}

export const GQL_QUERY_SINGLE_STORAGE_CONTAINER = gql`
  query singleStorageContainer($id: ID!) {
    singleStorageContainer(id: $id) {
      id
      container_id
      size
      type
      description
      is_active
      created_at
      updated_at

      ordersCount
      activeOrdersCount
      displayName

      next_sanitize_at
      sanitization_interval_days

      orderContainers {
        id
        order_id
        isPacked
        isUnpacked
      }
    }
  }
`

export function useFetchSingleStorageContainer (variables: SingleStorageContainerVariables) {
  return useQuery<SingleStorageContainerQuery, SingleStorageContainerVariables>(
    GQL_QUERY_SINGLE_STORAGE_CONTAINER,
    {
      variables,
      skip: !variables.id
    }
  )
}
